import { useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAnalyst } from "@/context/AnalystContext";
import VaelithChat from "@/components/VaelithChat";

// Floating Vaelith AI launcher. Hidden on the home screen (where the chat lives
// inline); appears on every other tab so the same conversation follows the user.
export default function AIAssistant() {
  const { open, setOpen } = useAnalyst() || {};
  const location = useLocation();
  if (location.pathname === "/") return null;

  return (
    <>
      <Button
        onClick={() => setOpen(!open)} data-testid="assistant-toggle"
        className={`fixed bottom-6 right-6 z-50 rounded-full h-14 pl-4 pr-5 shadow-xl gap-2 ${open ? "w-14 px-0 justify-center" : ""}`}
      >
        {open ? <X className="w-5 h-5" /> : <><Sparkles className="w-4 h-4" /><span className="font-medium hidden sm:inline">Ask Vaelith AI</span></>}
      </Button>

      {open && (
        <div data-testid="assistant-panel"
          className="fixed bottom-24 right-4 sm:right-6 z-50 w-[94vw] sm:w-[440px] h-[640px] max-h-[80vh] glass border border-border rounded-2xl shadow-2xl flex flex-col overflow-hidden">
          <div className="px-4 pt-3.5 pb-3 border-b border-border shrink-0 flex items-center gap-2">
            <span className="relative flex h-7 w-7 items-center justify-center rounded-full bg-accent/15 border border-accent/30">
              <Sparkles className="w-3.5 h-3.5 text-accent" />
            </span>
            <div>
              <div className="font-display font-semibold text-sm leading-none">Vaelith AI</div>
              <div className="font-mono-data text-[10px] text-muted-foreground uppercase tracking-wider mt-1">Search · Analyze · Negotiate</div>
            </div>
          </div>
          <VaelithChat variant="floating" onNavigate={() => setOpen(false)} />
        </div>
      )}
    </>
  );
}
